import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  BiContextProvidedValue,
  BiData,
  RemoveWidgetClickBiEvent,
  WidgetRemoveConfirmBiEvent,
} from '@wix/da-bi/pkg/events';
import SimpleTooltip from '@wix/da-ds/pkg/tooltips/dsPreset/SimpleTooltip';
import IconButton from '@wix/da-ds/pkg/Buttons/IconButton';
import TrashcanIcon from '@wix/da-ds/pkg/Icons/24x24/Trashcan';
import useModule from '../../../../../hooks/useModule';

interface Props {
  moduleId: number;
  className?: string;
  confirm?: (onConfirm: Function, confirmBtnBiData) => void;
  onRemove: () => void;
}

const RemoveButton: React.FC<Props> = ({
  moduleId,
  className,
  confirm,
  onRemove,
}) => {
  const { t } = useTranslation();
  const module = useModule(moduleId);

  return (
    <SimpleTooltip usePortal text={t('gruser.widgetbox.button.remove')}>
      <IconButton
        icon={TrashcanIcon}
        variant="edit-purple"
        size="medium"
        onClick={
          confirm
            ? () =>
                confirm(
                  onRemove,
                  BiData<WidgetRemoveConfirmBiEvent>({
                    evid: 270,
                    // can't use BiContextProvidedValue because confirmation modal won't have the context
                    widgetname: module?.name,
                    widgetzone: module?.zonename,
                  })
                )
            : onRemove
        }
        className={className}
        data-role="edit-control"
        biData={BiData<RemoveWidgetClickBiEvent>({
          evid: 280,
          widgetname: BiContextProvidedValue,
          widgetzone: BiContextProvidedValue,
        })}
        aria-label={t('gruser.widgetbox.button.remove')}
      />
    </SimpleTooltip>
  );
};
RemoveButton.displayName = 'RemoveButton';

export default RemoveButton;
